import React from "react";
import "./SubServiceHero.css";

const SubServiceHero = ({
  maintitle,
  title,
  secondtitle,
  seconddescription,
  thirdtitle,
  thirddescription,
  fourthtitle,
  fourthdescription,
  fivetitle,
  fivedescription,
  sixtitle,
  sixdescription,
  description,
  highlights,
  audience,
  pillLabel,
  onContact,
}) => (
  <div>
    <section className="subservice-hero-section">
      <div className="subservice-hero-left">
       
          <h2 className="subservice-hero-title">{title}</h2>
        
        <p className="subservice-hero-desc">{description}</p>
      </div>
      <div className="subservice-hero-left">
        <h2 className="subservice-hero-title">{secondtitle}</h2>
        <p className="subservice-hero-desc">{seconddescription}</p>
      </div>

      <div className="subservice-hero-right">
        <div className="subservice-hero-card">
          <div className="subservice-hero-card-header">
            {maintitle && maintitle.toUpperCase()}
          </div>
          <div className="subservice-hero-pill">{pillLabel}</div>
          <ul className="subservice-hero-features">
            {highlights &&
              highlights.map((item, idx) => (
                <li key={idx}>
                  <span className="subservice-hero-check">✔</span>
                  {item}
                </li>
              ))}
          </ul>
          <div className="subservice-hero-audience">{audience}</div>
          <button className="subservice-hero-contact-btn" onClick={onContact}>
            Contact Us
          </button>
        </div>
      </div>
    </section>

    <section className="container">
      <div className="subservice-hero-full">
        <h2 className="subservice-hero-title">{thirdtitle}</h2>
        <p className="subservice-hero-desc mb-5">{thirddescription}</p>
      </div>
      <div className="subservice-hero-full">
        <h2 className="subservice-hero-title">{fourthtitle}</h2>
        <p className="subservice-hero-desc mb-5">{fourthdescription}</p>
      </div>
      <div className="subservice-hero-full">
        <h2 className="subservice-hero-title">{fivetitle}</h2>
        <p className="subservice-hero-desc mb-5">{fivedescription}</p>
      </div>
      <div className="subservice-hero-full">
        <h2 className="subservice-hero-title">{sixtitle}</h2>
        <p className="subservice-hero-desc mb-5">{sixdescription}</p>
      </div>
    </section>
  </div>
);

export default SubServiceHero;
